/* eslint-disable func-names, max-len, no-underscore-dangle */
import 'chosen-js';

function initialise() {
  if ($('select').length > 0) {
            // select menu
    if (window.matchMedia('(min-width: 768px)').matches) {
                /* the view port is at least 768 pixels wide */

      const $selects = $('select').not('.cs-select').not('.chosen-ignore').not('.js-chosen-ignore');

      $selects.each(function () {
        const $this = $(this);

        const id = $this.attr('id');

        if (id && id.length) {
          const $lbl = $(`label[for=${id}]`);
          if ($lbl.length) {
            const lblText = $lbl.html();
            $this.attr('data-placeholder', lblText);
          }
        }
      });

      $selects.chosen();

      $('.chzn-select-deselect').chosen({ allow_single_deselect: true });
    }
  }
}

initialise();

Sys.WebForms.PageRequestManager.getInstance().add_endRequest(initialise);
